<template>
  <modal v-on="$listeners" @click.native="$emit('close')">
    <template v-slot:header>Field Notes</template>

    <ul class="list-reset p2 center mx-auto">
      <li class="mb1 h5 py2"><a href="https://www.anthropocene-curriculum.org" target="_blank">Anthropocene Curriculum</a></li>
      <li class="mb1 h5 py2"><a href="https://work.anthropocene-curriculum.org" target="_blank">Working Platform</a></li>
      <li class="mb1 h5 py2" v-if="!isStandalone()"><span v-on:click="openAddToHomeScreenModal">Add to Home Screen</span></li>
      <li class="mb1 h5 py2">
        <a v-if="loggedIn" @click="logout" class="pointer">Log Out</a>
        <a v-else @click="login" class="pointer">Log In</a>
      </li>
    </ul>
  </modal>
</template>

<script>
  import globals from '@/globals'

  export default {
    name: 'SideMenu',
    computed: {
      loggedIn () {
        return this.$store.getters.loggedIn
      }
    },
    methods: {
      login () {
        this.$store.dispatch('startLoginFlow')
      },
      async logout () {
        try {
          await this.$store.dispatch('logout')
          this.$store.dispatch('setBanner', {
            message: 'Logged out',
            duration: globals.banner.duration
          })
        } catch (err) {
          this.$store.dispatch('setBanner', {
            message: 'Error logging out',
            duration: globals.banner.duration
          })
          throw err
        }
      },
      openAddToHomeScreenModal () {
        this.$store.dispatch('addToHomescreen');
      },
      isStandalone () {
        if (window.navigator.standalone) {
          return true
        } else {
          return false
        }
      }
    }
  }
</script>
